// Email protection utility to prevent email harvesting by bots
export const protectEmail = (email) => {
  // ROT13 encoding for email protection
  const rot13 = (str) => {
    return str.replace(/[a-zA-Z]/g, (char) => {
      const start = char <= 'Z' ? 65 : 97;
      return String.fromCharCode(((char.charCodeAt(0) - start + 13) % 26) + start);
    });
  };
  
  return rot13(email);
};

// Decode ROT13 encoded email
export const decodeEmail = (encodedEmail) => {
  const rot13 = (str) => {
    return str.replace(/[a-zA-Z]/g, (char) => {
      const start = char <= 'Z' ? 65 : 97;
      return String.fromCharCode(((char.charCodeAt(0) - start + 13) % 26) + start);
    });
  };
  
  return rot13(encodedEmail);
};

// Create a protected email link
export const createProtectedEmailLink = (email, displayText = null) => {
  const handleEmailClick = (e) => {
    e.preventDefault();
    const decodedEmail = decodeEmail(email);
    window.location.href = `mailto:${decodedEmail}`;
  };
  
  return {
    href: '#',
    onClick: handleEmailClick,
    'data-email': email,
    children: displayText || decodeEmail(email)
  };
};

// React component for protected email display
export const ProtectedEmail = ({ email, displayText = null, className = '', ...props }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const decodedEmail = decodeEmail(email);
    window.location.href = `mailto:${decodedEmail}`;
  };
  
  return (
    <span 
      onClick={handleClick}
      className={`protected-email ${className}`}
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      {...props}
    >
      {displayText || decodeEmail(email)}
    </span>
  );
};

// Email addresses (protected)
export const PROTECTED_EMAILS = {
  SUPPORT: protectEmail('support@clubhosty.com'),
  SALES: protectEmail('sales@clubhosty.com'),
  BILLING: protectEmail('billing@clubhosty.com'),
  ABUSE: protectEmail('abuse@clubhosty.com')
};
